import { Controller } from "@hotwired/stimulus"

export default class CleanupMonitorController extends Controller {
  static targets = [
    "statusBadge", "progressBar", "progressText", "currentStep",
    "elapsedText", "removedCount", "etaText", "refreshHint",
    "rebuildButton"
  ]
  static values = { url: String, active: Boolean }

  connect() {
    if (this.activeValue) {
      this.poll()
    }
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  poll() {
    fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(data => this.update(data))
      .catch(() => {})
      .finally(() => {
        if (this.activeValue) {
          this._timer = setTimeout(() => this.poll(), 3000)
        }
      })
  }

  update(data) {
    if (this.hasStatusBadgeTarget) {
      this.statusBadgeTarget.textContent = this.capitalize(data.status)
      this.statusBadgeTarget.className = `status-badge status-${data.status}`
    }

    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${data.progress_percentage}%`
    }

    if (this.hasProgressTextTarget) {
      this.progressTextTarget.textContent =
        `${data.processed_geographies} / ${data.total_geographies} (${data.progress_percentage}%)`
    }

    if (this.hasCurrentStepTarget) {
      this.currentStepTarget.textContent = data.current_step || ""
    }

    if (this.hasElapsedTextTarget && data.elapsed_seconds !== null) {
      this.elapsedTextTarget.textContent = this.formatDuration(data.elapsed_seconds)
    }

    if (this.hasRemovedCountTarget) {
      this.removedCountTarget.textContent = this.formatNumber(data.removed_geographies)
    }

    if (this.hasEtaTextTarget) {
      this.etaTextTarget.textContent = data.eta_display || "Calculating..."
    }

    if (data.status === "completed" || data.status === "failed") {
      this.activeValue = false
      if (this.hasRefreshHintTarget) {
        if (data.status === "completed") {
          this.refreshHintTarget.textContent = "Cleanup complete. You can now Rebuild Geographies."
        } else {
          this.refreshHintTarget.textContent = "Cleanup failed. Check the error log."
        }
      }
      window.location.reload()
    }
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  formatNumber(n) {
    if (n === null || n === undefined) return "0"
    return Number(n).toLocaleString()
  }

  formatDuration(totalSeconds) {
    if (totalSeconds === null) return "--"
    const h = Math.floor(totalSeconds / 3600)
    const m = Math.floor((totalSeconds % 3600) / 60)
    const s = Math.floor(totalSeconds % 60)
    if (h > 0) return `${h}h ${m}m ${s}s`
    if (m > 0) return `${m}m ${s}s`
    return `${s}s`
  }
}
